<template>
  <el-dialog
    v-model="dialogVisible"
    title="激活会员"
    width="400px"
    center
    destroy-on-close
    :append-to-body="true"
    class="change-password-dialog"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-width="100px"
      @submit.prevent="submitForm"
    >
      <el-form-item label="激活码" prop="code">
        <el-input
          v-model="form.code"
          type="password"
          placeholder="请输入当前密码"
          show-password
        />
      </el-form-item>

      <el-form-item>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading">激活</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/api/request';
import requestV2 from '@/utils/requestV2';

import authState from '@/utils/authState';
import { useRouter } from 'vue-router';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'success']);
const router = useRouter();

// 弹窗显示状态
const dialogVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
});

// 表单引用
const formRef = ref(null);

// 表单数据
const form = ref({
  code: '',
  userid:''
});

// 处理中状态
const loading = ref(false);

// 表单验证规则
const rules = {
  code: [
    { required: true, message: '请输入激活码', trigger: 'blur' },
  ]
};

// 清空表单数据
const resetForm = () => {
  form.value = {
    code: '',
    userid:''
  };
  
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

// 监听对话框关闭
watch(dialogVisible, (newVal) => {
  if (!newVal) {
    // 当对话框关闭时重置表单
    resetForm();
  }
});

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return;
  let user = JSON.parse(localStorage.getItem('user'));
  form.value.userid = user.id;
  try {
    await formRef.value.validate();
    loading.value = true;
    
    // 使用request工具发送修改密码请求
    try {
      const response = await requestV2.post('/vip-code/activate', {
        code: form.value.code,
        user_id:form.value.userid
      });
      if(response.data.code == 200){
        // 成功后清空表单
        resetForm();
        // 关闭对话框
        dialogVisible.value = false;
        // 触发成功事件
        emit('success');

      }else{
        ElMessage.error('会员激活失败: '+ response.data.msg);
      }
      
      
      

    } catch (error) {
      console.error('会员激活失败:', error);
      
      // 根据错误类型提供友好的错误信息
      if (error.response && error.response.status === 401) {
        ElMessage.error('会员激活失败');
      } else {
        ElMessage.error(error.response?.data?.message || '会员激活失败');
      }
    }
  } catch (validationError) {
    console.error('表单验证失败:', validationError);
    ElMessage.warning('请正确填写所有必填项');
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
:deep(.change-password-dialog) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.change-password-dialog .el-dialog) {
  margin: 15vh auto !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
}

:deep(.change-password-dialog .el-dialog__body) {
  padding: 20px !important;
}
</style> 